module.exports = __webpack_public_path__ + "img/Office.4a972f93.jpg";